import create from 'zustand';
import { IProductFilterExpand } from '~/templates/blocks/components/M170ProductFilter/models/M170ProductFilter';
import { ProductFilterExpandActions } from '../models/ProductFilterExpandState';
import { toggleExpandedFacet } from './reducers/toggleExpandedFacet';
import { toggleExpandedSorting } from './reducers/toggleExpandedSorting';

export const useProductFilterExpandState = create<IProductFilterExpand>((set, get) => {
	const actions: ProductFilterExpandActions = {
		toggleExpandedFacet: (facetId: string): void => set(toggleExpandedFacet(get(), facetId)),
		toggleExpandedSorting: (): void => set(toggleExpandedSorting(get())),
	};

	return {
		...actions,
		expandedOption: null,
		expandedOptionId: null,
	};
});
